import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';

import CartaoModal from './modals/Cartao';
import Paginacao from '../../../../components/utils/paginacao';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Cartoes = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const [cartoes, setCartoes] = useState([]);
    const [filtroBandeira, setFiltroBandeira] = useState('');
    const [filtroTipo, setFiltroTipo] = useState('');

    const [selectedCartao, setSelectedCartao] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const limit = 10;

    const tiposCartao = [
        { value: '', label: 'Todos os tipos' },
        { value: 'debito', label: 'Débito' },
        { value: 'credito_avista', label: 'Crédito à Vista' },
        { value: 'credito_parcelado', label: 'Crédito Parcelado' }
    ];

    const fetchCartoes = async (currentPage) => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: currentPage,
                limit: limit,
                bandeira: filtroBandeira,
                tipo: filtroTipo
            };

            const response = await api.get('/cartoes', { params });

            setCartoes(response.data.records || []);
            setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
            setTotalRegistros(response.data.totalRegistros || 0);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar os dados. Tente novamente mais tarde.');
        } finally {
            Swal.close();
        }
    };

    useEffect(() => {
        fetchCartoes(currentPage);
    }, [currentPage]);

    const handleFiltrar = () => {
        setCurrentPage(1);
        fetchCartoes(1);
    };

    const handleLimparFiltros = () => {
        setFiltroBandeira('');
        setFiltroTipo('');
        setCurrentPage(1);
    };

    const handlePageChange = (currentPage) => {
        setCurrentPage(currentPage);
    };

    const openModal = (cartao = null) => {
        setSelectedCartao(cartao);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedCartao(null);
        setIsModalOpen(false);
    };

    const handleCartaoAtualizado = () => {
        fetchCartoes(currentPage);
        closeModal();
    };

    const handleEditCartao = (cartao) => {
        openModal(cartao);
    };

    const handleDeleteCartao = async (cartao) => {
        const result = await Swal.fire({
            title: 'Tem certeza?',
            text: `Deseja excluir o cartão "${cartao.bandeira}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/cartoes/${cartao.id}`);
                Swal.fire('Excluído!', 'Cartão foi excluído com sucesso.', 'success');
                fetchCartoes(currentPage);
            } catch (error) {
                Swal.fire('Erro!', error.response.data.message || 'Não foi possível excluir o cartão.', 'error');
            }
        }
    };

    const formatTipo = (tipo) => {
        const tipos = {
            'debito': 'Débito',
            'credito_avista': 'Crédito à Vista',
            'credito_parcelado': 'Crédito Parcelado'
        };
        return tipos[tipo] || tipo;
    };

    const formatPoliticaAntecipacao = (politica) => {
        const politicas = {
            'nao': 'Não Antecipar',
            'todas': 'Antecipar Todas',
            'primeira': 'Antecipar Primeira'
        };
        return politicas[politica] || politica;
    };

    const getTipoColor = (tipo) => {
        const colors = {
            'debito': 'primary',
            'credito_avista': 'success',
            'credito_parcelado': 'info'
        };
        return colors[tipo] || 'secondary';
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn btn-outline-secondary me-3"
                                    onClick={() => navigate('/financeiro/cadastros')}
                                    title="Voltar para Cadastros"
                                >
                                    <FaArrowLeft />
                                </button>
                                <h4 className="fw-bold mb-0">Cartões</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 mb-3">
                        <div className="col-md-6 col-12">
                            <button className="btn btn-outline-primary" onClick={() => openModal()}>
                                <FaPlus /> Adicionar Cartão
                            </button>
                        </div>
                    </div>

                    <div className="row mt-4 mb-4">
                        <div className="col-lg-3 col-12">
                            <label className="form-label fw-bold">Bandeira</label>
                            <input
                                type="text"
                                autoComplete="off"
                                placeholder="Digite a bandeira"
                                value={filtroBandeira}
                                className="form-control"
                                onChange={(e) => setFiltroBandeira(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                            <label className="form-label fw-bold">Tipo</label>
                            <select
                                className="form-select"
                                value={filtroTipo}
                                onChange={(e) => setFiltroTipo(e.target.value)}
                            >
                                {tiposCartao.map(tipo => (
                                    <option key={tipo.value} value={tipo.value}>
                                        {tipo.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-lg-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                            <div className="d-flex gap-2 w-100 justify-content-end">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={handleLimparFiltros}
                                >
                                    Limpar
                                </button>
                                <button
                                    className="btn btn-custom-primary"
                                    onClick={handleFiltrar}
                                >
                                    <FaFilter /> Filtrar
                                </button>
                            </div>
                        </div>
                    </div>

                    {error ? (
                        <p className="error-message">{error}</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead className="table-custom-primary">
                                    <tr>
                                        <th>Bandeira</th>
                                        <th>Tipo</th>
                                        <th>Conta Bancária</th>
                                        <th>Prazo (dias)</th>
                                        <th>Taxa (%)</th>
                                        <th>Taxa Antecipação (%)</th>
                                        <th>Política Antecipação</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cartoes.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                Nenhum cartão encontrado.
                                            </td>
                                        </tr>
                                    ) : (
                                        cartoes.map((cartao) => (
                                            <tr key={cartao.id}>
                                                <td>{cartao.bandeira}</td>
                                                <td>
                                                    <span className={`badge bg-${getTipoColor(cartao.tipo)}`}>
                                                        {formatTipo(cartao.tipo)}
                                                    </span>
                                                </td>
                                                <td>{cartao.contaBancaria?.nome_exibicao || 'N/A'}</td>
                                                <td>D+{cartao.prazo_dias}</td>
                                                <td>{parseFloat(cartao.taxa).toFixed(2)}%</td>
                                                <td>{parseFloat(cartao.taxa_antecipacao).toFixed(2)}%</td>
                                                <td>{formatPoliticaAntecipacao(cartao.politica_antecipacao)}</td>
                                                <td className="text-center">
                                                    <div className="d-flex gap-2 justify-content-center">
                                                        <button
                                                            className="btn btn-custom-secondary btn-sm"
                                                            onClick={() => handleEditCartao(cartao)}
                                                            title="Editar"
                                                        >
                                                            <FaEdit />
                                                        </button>
                                                        <button
                                                            className="btn btn-custom-secondary btn-sm ms-3"
                                                            onClick={() => handleDeleteCartao(cartao)}
                                                            title="Excluir"
                                                        >
                                                            <FaTrashAlt />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <div className="mb-3">
                            <span>
                                Total de registros: <strong>{totalRegistros}</strong>
                            </span>
                        </div>
                        <Paginacao
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <CartaoModal
                    onClose={closeModal}
                    cartao={selectedCartao}
                    onCartaoAtualizado={handleCartaoAtualizado}
                />
            )}
        </div>
    );
};

export default Cartoes;